import apiClient from "./ApiClient";

export const getTickets = async (filter) => {
    try {
        const response = await apiClient.post(`/api/Ticket/get`, filter);
        return response.data;
    } catch (error) {
        console.error("Error fetching tickets:", error);
        throw error;
    }
};

export const saveTicket = async (formData) => {
    try {
        const response = await apiClient.post(`/api/Ticket/save`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error("Error saving ticket:", error);
        throw error;
    }
};

export const getTicketLogs = async (ticketID) => {
    try {
        const response = await apiClient.get(`/api/Ticket/logs/${ticketID}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching ticket logs:", error);
        throw error;
    }
};

export const getTicketDocuments = async (ticketID) => {
    try {
        const response = await apiClient.get(`/api/Ticket/documents/${ticketID}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching ticket documents:", error);
        throw error;
    }
};

export const getTicketNotifications = async (recipientID) => {
    try {
        const response = await apiClient.get(`/api/Ticket/notifications/${recipientID}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching ticket notifications:", error);
        throw error;
    }
};

export const markTicketNotificationAsRead = async (logID, recipientID) => {
    try {
        const response = await apiClient.post(`/api/Ticket/mark-as-read/${logID}/${recipientID}`);
        return response.data;
    } catch (error) {
        console.error("Error marking ticket notification as read:", error);
        throw error;
    }
};
